import script from "./Tooth.vue?vue&type=script&setup=true&lang=js"
export * from "./Tooth.vue?vue&type=script&setup=true&lang=js"

import "./Tooth.vue?vue&type=style&index=0&id=b16798f6&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b16798f6"]])

export default __exports__